export * from './styles'
export * from './request-statuses'
export * from './api-constants'
export * from './route_names'
export * from './payment-links'
export * from './custom-event'
export * from './editor'
export * from './automation'
export * from './segmentation'
export * from './environment'
export * from './timezones'

export const $isDev = !!process.dev
export const isClient = !!process.client
export const webUrl = process.env.NUXT_WEB_URL
export const isLiveEnvironment = process.env.NUXT_IS_LIVE_ENVIRONMENT ?? true
export const runScriptsInProduction =
  process.env.NUXT_RUN_SCRIPTS_IN_PRODUCTION ?? 'disabled'

export const PAGE_KEY = Symbol('page')

export const AUTH_KEY = Symbol('dashboard-user')
export const ONBOARDING_STEP_KEY = Symbol('onboarding-step')
export const METRICS_KEY = Symbol('metrics')

export const SessionTimeoutInSeconds = process.dev ? 1000 * 60 * 30 : 1000 * 60 * 5 // 5 minutes

export const DateFormatWithTime = 'PPpp'
export const DateFormat = 'PPP'
export const TimeFormat = 'pp'

export const ExcelFileMimeTypes = 'application/vnd.ms-excel,text/csv,.xlsx'

export const ProviderInputEncryptionMessage =
  'Keys are encrypted on our platform for security & compliance.'
